import { LinkedFirestoreOfflineDocument } from "@/core/modules/firestore/objects/LinkedFirestoreOfflineDocument";
import { VaccineType } from "./VaccineType";

import { StringField } from "@/core/fields";

export class LinkedVaccineType extends LinkedFirestoreOfflineDocument {
  public name: string | undefined = undefined;

  public constructor(firestoreData?: Record<string, unknown>) {
    super();
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);
  }

  public static createFromVaccineType(vaccineType: VaccineType): LinkedVaccineType {
    const linkedVaccineType: LinkedVaccineType = new LinkedVaccineType();
    linkedVaccineType.id = vaccineType.id;
    linkedVaccineType.name = vaccineType.name;

    return linkedVaccineType;
  }

  public fromFirestore(data: Record<string, unknown>): LinkedVaccineType {
    super.fromFirestore(data);

    this.name = StringField.fromFirestore(data.name);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.name = StringField.toFirestore(this.name);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): LinkedVaccineType {
    super.fromOfflineCache(data);

    this.name = StringField.fromOfflineCache(data.name);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.name = StringField.toOfflineCache(this.name);

    return firestoreData;
  }
}
